import { render } from "./PrintSprinklerData.vue?vue&type=template&id=64b3f034&scoped=true"
import script from "./PrintSprinklerData.vue?vue&type=script&lang=js"
export * from "./PrintSprinklerData.vue?vue&type=script&lang=js"

import "./PrintSprinklerData.vue?vue&type=style&index=0&id=64b3f034&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b3f034"]])

export default __exports__